module.exports = __webpack_public_path__ + "static/assets/fe959455d078c67608cfebeeed446241.svg";